import { RequestStepsQueryService } from "../../../services/request/RequestStepsQueryService";
import { StepModel } from "../../models/Steps";
import { IQueryRequestStepsRepository } from "../../ports/request/IQueryRequestStepsRepository";
import Query from "../Query";

class RequestStepsQuery
  extends Query<StepModel>
  implements IQueryRequestStepsRepository
{
  constructor(public queryService: RequestStepsQueryService) {
    super(queryService);
  }
  public async findBySlug(slug: string): Promise<StepModel | null> {
    return this.queryService.findBySlug(slug);
  }
}

export default RequestStepsQuery;
